import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const PaginatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${pxToRem(20)};
  flex-wrap: wrap;
  padding: ${pxToRem(15)} ${pxToRem(25)};
  border-top: ${pxToRem(1.25)} solid ${({ theme }) => theme.colors.inkBorder};
  background: ${({ theme }) => theme.colors.white};
`;

export const NavButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${pxToRem(5)};
  margin-left: auto;
`;

export const PageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(5)};

  span {
    min-width: ${pxToRem(20)};
    text-align: center;
    color: ${({ theme }) => theme.colors.inkMuted};
    font-size: ${pxToRem(16)};
    font-weight: 400;
  }
`;

export const PageButton = styled.button`
  min-width: ${pxToRem(40)};
  height: ${pxToRem(40)};
  padding: 0 ${pxToRem(11.25)};
  border: ${pxToRem(1.25)} solid transparent;
  border-radius: ${pxToRem(10)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkSoft};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${pxToRem(16)};
  font-weight: 400;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.inkSurface};
    color: ${({ theme }) => theme.colors.ink};
  }

  &:focus-visible {
    outline: ${pxToRem(2.5)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2.5)};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.inkMuted};
    cursor: default;
    opacity: 0.55;
  }
`;

export const ActivePageButton = styled(PageButton)`
  border-color: ${({ theme }) => theme.colors.brand};
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 500;
  cursor: default;

  &:hover {
    background: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const NavButton = styled.button`
  height: ${pxToRem(40)};
  padding: 0 ${pxToRem(11.25)};
  border: ${pxToRem(1.25)} solid transparent;
  border-radius: ${pxToRem(10)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkSoft};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${pxToRem(16)};
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.inkSurface};
    color: ${({ theme }) => theme.colors.ink};
  }

  &:focus-visible {
    outline: ${pxToRem(2.5)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2.5)};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.inkMuted};
    cursor: default;
    opacity: 0.55;
  }
`;
